export const FETCH_SMS_BALANCE = "FETCH_SMS_BALANCE"
export const UPDATE_SMS_BALANCE = "UPDATE_SMS_BALANCE"
export const CLEAR_SMS_BALANCE = "CLEAR_SMS_BALANCE"